
module.exports = {

    request: [{
        field: 'subject',
        required: true,
        description: 'The from name of the SMS, usually your company name, Must be 3-11 characters long and have no spaces'
    }, {
        field: 'toAddress',
        required: true,
        description: `The recipient's phone number, must be a valid UK mobile number`
    }, {
        field: 'SubscriberId',
        required: false,
        description: `If specified it will update the contact's phone number to the toAddress, otherwise it will create a new contact`
    }, {
        field: 'emailAddress',
        required: false,
        description: `If you do not specificy a SubscriberId you must also add the emailAddress field so we can create a new contact`
    }, {
        field: 'content',
        required: false,
        description: 'The content of the SMS message, you can specify the TemplateId if you want to use predefined content'
    },
    {
        field: 'TemplateId',
        required: false,
        description: 'The ID of the SMS template to use, you can specify the content field if you want to send custom content'
    },
    {
        field: 'dontTrackLinks',
        required: false,
        description: 'If true, the links in the SMS will not be tracked'
    }
    ],
    response: [{
        field: 'id',
        description: 'The unique identifier for the SMS transaction'
    }]
}